theme.Type = (function () {
  function cleaner(el) {
    if (el.innerHTML === '&nbsp;' || el.innerHTML === '') {
      el.parentNode.removeChild(el);
    }

    if (!el.innerHTML.replace(/\s/g, '').length) {
      el.remove();
    }
  }

  const elements = document.querySelectorAll(
    '.article__body p, .article__body span, .article__body strong'
  );
  elements.forEach(cleaner);
})();
